<template>
	<div id="FirstTimeTraveler" class="FirstTimeTraveler">
		<NavOther/>
		<div class="slides-container">
            <section id="one" class="section-box">
                <div id="slide-one" class="slide first" :class="{'in-zoom':inZoomActive}">
                    <div class="what-do-you" :class="{'active': active}">
                        <div class="text-what-do-you">
                            <ul>
                                <li data-aos="zoom-out" data-aos-delay="600">What</li>
                                <li data-aos="zoom-out" data-aos-delay="900">do you know</li>
                                <li data-aos="zoom-out" data-aos-delay="1200">about Mongolia</li>
                                <li data-aos="zoom-out" data-aos-delay="1500">?</li>
                            </ul>
                        </div>
                        <img :src="imgScrollDown" alt="scroll-donw" class="img-scroll" @click="nextSlide2">
                    </div>
                    <div class="ig">
                        <ImagesBoard :perPage="18" :rowHeight="200" tag="nature" />
                    </div>
                    <div class="detail">
                        <p class="text-center title" data-aos="zoom-out" data-aos-delay="600">Nomadic by Nature</p>
                        <p class="text-center welcome" data-aos="zoom-out" data-aos-delay="900">Welcome to <span>Mongolia</span></p>
                        <div class="map-zoom" @click="inZoom">
                            <img :src="mapZoom" alt="">
                        </div>
                        <div class="description">
                            <p data-aos="zoom-out" data-aos-delay="1200">You have probably heard of Mongolia through the famous tales of Genghis Khan, history books and Hollywood films. Very few have actually witnessed the raw beauty, culture and heritage of the country. When people talk about the road less travelled, there is no better place than Mongolia as it is one of the world’s least explored travel destinations.</p>
                            <p data-aos="zoom-out" data-aos-delay="1500">Imagine vast lands as far as the eyes can see, deterred only by tall mountains and trees. Cobalt blue skies hover over scenic landscape encompassing rivers, lakes, forests and deserts. Here, nature is only rivalled by the traditional hospitality of its people, their culture and heritage.</p>
                            <p data-aos="zoom-out" data-aos-delay="1800">Come and experience the culture and heritage of the last surviving nomadic societies. Adventure awaits you…</p>
                        </div>
                        <img :src="imgScrollDown" alt="scroll-donw" class="img-scroll" @click="showWhatDoYou">
                    </div>
                    <div class="zoom" @click="inZoom">
                        <div class="bg-map">
                            <svg xmlns="http://www.w3.org/2000/svg" width="298.953" height="134.625" viewBox="0 0 298.953 134.625" id="circle-map">
                                <path id="Path_12410" data-name="Path 12410" d="M827.456,136.508q-.018-1.321-.111-2.642a48.419,48.419,0,0,0-.645-5.242,47.171,47.171,0,0,0-2.97-10.029,54.452,54.452,0,0,0-11.211-16.64,81.285,81.285,0,0,0-14.685-11.81,145.5,145.5,0,0,0-31.316-14.525,256.057,256.057,0,0,0-30.042-8.059c.036.079-.564.019-1.936-.2-4.459-.721-10.3-1.763-17.3-2.832-5.29-.675-7.175-.776-11.434-1.173q-5.35-.621-10.711-1.109c-1.232-.147-3.512-.4-8.147-.771l-4.505-.2-6.038-.35c-1.383-.121-5.638-.365-11.324-.515-2.843-.073-6.043-.122-9.446-.1-1.708.015-3.451.044-5.3.131a29.284,29.284,0,0,0-3.141.285c-.3.047-.639.109-1.035.2a7.85,7.85,0,0,0-1.7.6l-.35.184c-.157.091-.31.189-.46.291l-.112.079-.158.12c-.1.082-.2.168-.3.255a5.549,5.549,0,0,0-1.843,3.825,5.624,5.624,0,0,0,.032.928c.018.153.042.306.072.457.028.13.056.241.089.362a5.8,5.8,0,0,0,.245.7l.073.168.058.119.122.232c.032.056.068.11.1.165a305.319,305.319,0,0,0-31.6,3.541,214.49,214.49,0,0,0-29.558,7,120.237,120.237,0,0,0-27.446,12.315,68.068,68.068,0,0,0-11.831,9.312,46.634,46.634,0,0,0-8.915,12.184,39.5,39.5,0,0,0-4.032,14.514,34.932,34.932,0,0,0,1.934,14.894,33.44,33.44,0,0,1-1.774-8.6,24.389,24.389,0,0,1-.029-3.609c.047-.291.032.353.12,2.006a35.593,35.593,0,0,0,1.371,7.954A37.988,37.988,0,0,0,537,153.741a62.325,62.325,0,0,0,15.955,13.877c13.927,8.813,34.155,16.079,60.2,20.877-2.34-.532,3.948.662,8.484,1.261a405.627,405.627,0,0,0,53.765,4.27c-11.678.067-22.265-.3-31.568-.858a419.511,419.511,0,0,0,48.3,1.644,385.631,385.631,0,0,0,46.091-3.744,244.693,244.693,0,0,0,43.106-9.905,127.668,127.668,0,0,0,19.825-8.513,64.786,64.786,0,0,0,17.26-13.049,37.119,37.119,0,0,0,6.232-9.306,30.225,30.225,0,0,0,2.758-11.05c.032-.472.033-.952.045-1.416ZM577.307,84.9a193.819,193.819,0,0,1,35.858-8.773,309.525,309.525,0,0,1,34.187-3.315c.538.157,1.051.3,1.544.418.278.069.54.124.811.186-6.94.223-13.374.633-19.293,1.163A267.222,267.222,0,0,0,598.7,79.246c-8.276,1.763-14.314,3.534-18.4,4.832s-6.218,2.127-6.663,2.258A27.664,27.664,0,0,1,577.307,84.9Zm240.67,60.042c.16-.217.141.161-.241,1.291A23.692,23.692,0,0,1,814.2,152.6a39.285,39.285,0,0,1-6.925,6.923c-5.757,4.593-13.71,8.843-23.109,12.537-4.827,1.865-8.409,3.188-12.375,4.411a218.229,218.229,0,0,1-24.718,5.937c-7.519,1.368-14.287,2.265-20.332,2.9-6.945.85-14.6,1.567-22.063,2.021s-14.715.668-20.847.676a406.892,406.892,0,0,1-44-1.833c-12.762-1.239-23.453-2.953-31.707-4.573-.682-.185,3.8.556,4.748.575.472.013.056-.124-2.328-.639-2.377-.534-6.741-1.394-14.033-3.247.344.152-.578.039-3.735-.738-1.576-.394-3.712-.956-6.5-1.8s-6.233-1.961-10.376-3.554a29,29,0,0,0,3.683,1.425c-10.512-3.631-20.223-8.132-28.25-14.027a49.892,49.892,0,0,1-10.452-10.109,30.86,30.86,0,0,1-5.658-12.147,28.836,28.836,0,0,1-.608-6.5A33.617,33.617,0,0,1,540.54,112.5a46.232,46.232,0,0,1,8.879-9.591,70.934,70.934,0,0,1,11.09-7.438,124.752,124.752,0,0,1,25.359-10.121,217.615,217.615,0,0,1,27.649-5.916,340.576,340.576,0,0,1,52.1-3.529c1.091.113,2.133.209,3.114.289,5.806.466,9.676.4,11.508-.15a24.411,24.411,0,0,0,2.667-.954c4.342.244,8.666.558,12.528.86A272.251,272.251,0,0,1,737.021,81.1a318.068,318.068,0,0,0-31.988-5.346c-7.014-.819-13.738-1.4-20.175-1.794a2.195,2.195,0,0,0,.641-.82,350.953,350.953,0,0,1,40.816,4.741c7.7,1.381,15.565,3.08,23.485,5.254a171.359,171.359,0,0,1,23.712,8.257,101.109,101.109,0,0,1,11.433,5.883,59.2,59.2,0,0,1,10.344,7.752,29.744,29.744,0,0,1,7.327,10.4,19.879,19.879,0,0,1,1.354,6.148,33.036,33.036,0,0,1-.39,6.52,34.462,34.462,0,0,1-4.579,12.4,46.423,46.423,0,0,1-8.722,10.407c-6.849,6.18-15.171,10.868-23.914,14.631a161.976,161.976,0,0,1-27.541,8.761,214.635,214.635,0,0,1-29.04,4.518,178.386,178.386,0,0,1-29.594.261,85.008,85.008,0,0,1-14.508-2.338A33.787,33.787,0,0,1,659,174.265c-2.029-1.054-3.879-2.471-4.487-4.158-.437-.409-.734-.812-.985-1.015s-.472-.209-.662.158a3.183,3.183,0,0,0,.061,2.3,8.857,8.857,0,0,0,3.207,4.01c3.605,2.752,9.981,5.057,19.25,6.432,9.283,1.353,21.548,1.887,37.233.512l.3-.035q3-.3,6-.681c1.757-.16,8.135-.95,16.039-2.541a195.96,195.96,0,0,0,25.205-6.8,117.517,117.517,0,0,0,22.107-10.375A74.157,74.157,0,0,0,793.118,154a50.715,50.715,0,0,0,9.35-11.123,38.135,38.135,0,0,0,5.687-18.648,27.212,27.212,0,0,0-.125-4.215,24.855,24.855,0,0,0-2.5-8.291,39.67,39.67,0,0,0-11.272-13.063,79.3,79.3,0,0,0-12.673-7.96c1.059.528,3.143,1.532,5.868,3a96.543,96.543,0,0,1,10.613,6.607A63.562,63.562,0,0,1,809.2,110.42a43.155,43.155,0,0,1,7.575,12.531,38.224,38.224,0,0,1,1.212,4.192c.28,1.266.393,2.152.27,1.92a40.952,40.952,0,0,1,.911,8.265A21.857,21.857,0,0,1,817.977,144.946Z" transform="translate(-528.51 -60.302)" fill="#2c2c2c"/>
                            </svg>
                            <span class="name-mongolia">Mongolia</span>
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="84" height="84" viewBox="0 0 84 84" id="scrolldown-map">
                            <g id="Group_563" data-name="Group 563" transform="translate(-893 -952.195)">
                                <circle id="Ellipse_5" data-name="Ellipse 5" cx="42" cy="42" r="42" transform="translate(893 952.195)" opacity="0.039"/>
                                <text id="SCROLL_DOWN" data-name="SCROLL DOWN" transform="translate(905 1017.117)" fill="#fff" font-size="8" font-family="SegoeUI, Segoe UI"><tspan x="0" y="0">SCROLL DOWN</tspan></text>
                                <g id="Group_46" data-name="Group 46" transform="translate(903 964)">
                                <path id="Path_784" data-name="Path 784" d="M864.847,187.631s-6.652-2.232-8.666-3.469a18.154,18.154,0,0,1-.495,2.327c1.987.908,6.012,2.623,7.722,2.392,0,0-.752,1.809,1.683,1.809h2.065S867.589,188.881,864.847,187.631Z" transform="translate(-828.044 -155.169)" fill="#fff"/>
                                <path id="Path_785" data-name="Path 785" d="M854.941,125.277A37.744,37.744,0,0,0,851,122.059l-1.246-2.209-.562,2.209-1.435-2.167-.063,3.117a6.692,6.692,0,0,0-.747-.108,6.806,6.806,0,0,0-1.786-2.123,2.51,2.51,0,0,0-.751-.407,2.376,2.376,0,0,0-1.527.1,7.01,7.01,0,0,0-1.357.755,8.512,8.512,0,0,1,3.681,1.639c-.2.01-.406.026-.621.048a6.349,6.349,0,0,0-3.206-1.353,8.956,8.956,0,0,0-3.485,2.355c-.223.252-.444.592-.312.9l-.458-.187a11.237,11.237,0,0,0-2.963,3.106c.341.14.669.289.99.45a21.217,21.217,0,0,0-2.388,3.591s-5.748.742-9-.373c0,0-7.371-3.713-13.618,1.485,0,0-12.246,8.049-15.116,1.859,0,0-.5,8.044,7.62,6.436,0,0,5.5-1.215,6.584-4.966-.193.6-.91,3.824,4.1,8.209,1.248,1.088,3.747,3.65,3.747,3.65s.624,4.027,2.438,6.354c0,0,5.747,6.067,7.248,6.561,0,0-1.131,1.858,1.939,1.858h1.622s.941-.431-.873-2.167c0,0-6.228-5.058-7.812-7.182-.43-.572-1-2.042-.123-2.845a11.188,11.188,0,0,0,.949-3.522,4.359,4.359,0,0,1,.053-.776,10.815,10.815,0,0,0-2.08-6.587,7.983,7.983,0,0,1,2.841,5.726,1.209,1.209,0,0,1,.546.144c2.584,1.253,6.257,1.878,11.215,1.349a17.492,17.492,0,0,1-1.749-4.167,12.076,12.076,0,0,0,2.977,4.16,28.356,28.356,0,0,0,5.615,2.309s1.311,2.355-4.309,2.1c0,0,.624-1.73-2.5-1.73-1.313,0-2.5.494.936,2.723a3.942,3.942,0,0,0,3.871.312s7.876-1.115,3.564-4.706c0,0-3.7-2.1-.063-2.1a16.693,16.693,0,0,1,4.688-.665s1.311-.7,1,5.242c0,0-.628.434.06,1.423,0,0,.126,1.053-.75.743,0,0-1.62-.125.627,2.1,0,0,1.125,1.235,1.377-.311l.247-9.289s.442-3.045-2.935-2.414c-1.08.2-3.436,1.329-3.935-1.96a11.132,11.132,0,0,1,4.562-11.039s3,1.793,5.81.495c0,0,2.56,2.2,4.248.247C859.394,129.3,859.819,129.432,854.941,125.277Z" transform="translate(-795.028 -119.85)" fill="#fff"/>
                                </g>
                            </g>
                        </svg>
                    </div>
                    <div class="bg-slide" :class="{'active-slide':activeSlide1}"></div>
                </div>
            </section>
            <section id="two" class="section-box">
                <div id="slide-two" class="slide two">
                    <div class="bg-slide2-1" :class="{'active-slide':activeSlide1}"></div>
                    <div class="bg-slide2-2" :class="{'active-slide':activeSlide2}"></div>
                    <div class="detail-two">
                        <div class="img-cover" :class="{'cover-active':del}">
                            <div class="img-left">
                                <div class="ig" :class="{'show':showIG}">
                                    <ImagesBoard :perPage="12" :rowHeight="200" tag="community-based" />
                                </div>
                            </div>
                            <div class="img-right">
                                <div class="ig" :class="{'show':showIG}">
                                    <ImagesBoard :perPage="12" :rowHeight="200" tag="community-based" />
                                </div>
                            </div>
                            <img :src="imgScrollDown2" alt="scroll-donw" class="img-scroll2" :class="{'del' : del}" @click="openCover">
                        </div>
                        <div class="description" :class="{'active':del}">
                            <ul class="description-first">
                                <li data-aos="zoom-out" data-aos-delay="300">Did you know</li>
                                <li data-aos="zoom-out" data-aos-delay="600">that we are always </li>
                                <li data-aos="zoom-out" data-aos-delay="900"><span class="text-911457">on the move</span> but still </li>
                                <li class="text-911457" data-aos="zoom-out" data-aos-delay="1200">welcome everyone into </li>
                                <li data-aos="zoom-out" data-aos-delay="1500"><span class="text-911457">our communities</span> ?</li>
                            </ul>
                            <div class="description-two">
                                <p data-aos="zoom-out" data-aos-delay="1800">The world is changing around us but we have always managed to stay true to our millennia-old nomadic lifestyle. Over a third of Mongolia people are still nomadic herders.</p>
                                <p data-aos="zoom-out" data-aos-delay="2100">Growing trends and shifts toward sustainability and community-based tourism makes Mongolia the ideal destination for travellers who seek just that. Through locally-led tours, visitors can discover the natural beauty, delicious food, exciting festivals and immerse themselves in the cultural heritage of local communities.</p>
                                <div class="exploreOur" :class="{'show':show}">
                                    <div class="exploreOur-img">
                                        <img :src="explore" alt="explore">
                                    </div>
                                    <p class="exploreOur-title">
                                        Guvanbulag Community
                                    </p>
                                    <p class="Lorem">
                                        Find out more how Mongolian Communities are welcome travelers to their homes and heaths.
                                    </p>
                                    <router-link class="btn btn-explore btn-block" :to="{ name: 'themes', params: { nametravel: 'community-based' }}">
                                        Explore Our Communities
                                    </router-link>
                                </div>
                            </div>
                            <img :src="imgScrollDown2" alt="scroll-donw" class="img-scroll2" :class="{'sb2Hide':sb2Hide}" @click="openIG">
                        </div>
                    </div>
                </div>
            </section>
            <section id="three" class="section-box">
                <div id="slide-three" class="slide three" >
                    <div class="bg-slide3-1" :class="{'active-slide':activeSlide2}"></div>
                    <div class="bg-slide3-2" :class="{'active-slide':activeSlide3}"></div>
                    <div class="description">
                        <ul>
                            <li data-aos="zoom-out" data-aos-delay="300">Did you know</li>
                            <li data-aos="zoom-out" data-aos-delay="600">the <span class="color-li">Man of the</span></li>
                            <li data-aos="zoom-out" data-aos-delay="900"><span class="color-li">Millennium</span> is </li>
                            <li data-aos="zoom-out" data-aos-delay="1200"><span class="color-li">Mongolian</span>?</li>
                        </ul>
                        <p data-aos="zoom-out" data-aos-delay="1500">We have all heard the tales of the (in)famous Genghis Khan. A warrior. A leader. An emperor of one of the biggest empires – the Mongols. In history, there is no one who else has been as feared and respected simultaneously. No one who was as controversial or rather, misunderstood.</p>
                        <p data-aos="zoom-out" data-aos-delay="1800">Genghis Khan conquered vast lands stretching from the Pacific Ocean to Eastern Europe, from Siberia to the Persian Gulf thereby changing the course of history. He was the beginning to where we are now. By creating his empire, he shrank the world as did Christopher Columbus after him.</p>
                        <p data-aos="zoom-out" data-aos-delay="2100">Despite the greatness of Genghis Khan, he embodied the nomadic way of life of the Mongolians. This is what makes him Man of the Millennium and he was a Mongolian. Only by visiting the country will you truly learn of his dynasty and our history.</p>
                        <div class="img">
                            <img :src="imgScrollDown3" alt="scrolldown" @click="slide3">
                        </div>
                    </div>
                    <div class="img-three">
                        <div class="ig" :class="{'show-box-three':isHide}">
                            <ImagesBoard :perPage="12" :rowHeight="200" tag="history" />
                        </div>
                        <div class="box-historical" :class="{'ishide':isHide}">
                            <img :src="historical" alt="historical">
                            <p class="title">Genghis Khan Equestrian Statue</p>
                            <p class="lorem">Mongolia has a millennia-old history and culture. We are proud of and feel connected to our ancestry.</p>
                            <router-link class="btn btn-historical btn-block" :to="{ name: 'themes', params: { nametravel: 'history' }}">
                                Explore Historical Places
                            </router-link>
                        </div>
                    </div>
                </div>
            </section>
            <section id="four" class="section-box">
                <div id="slide-four" class="slide four">
                    <div class="bg-slide4-1" :class="{'active-slide':activeSlide3}"></div>
                    <div class="bg-slide4-2" :class="{'active-slide':activeSlide4}"></div>
                    <div class="ig" :class="{'show-ig-four':showIgFour}">
                        <ImagesBoard :perPage="12" :rowHeight="200" tag="bird-watching" />
                    </div>
                    <div class="description">
                        <ul>
                            <li data-aos="zoom-out" data-aos-delay="300">Did you know</li>
                            <li data-aos="zoom-out" data-aos-delay="600"><span>Mongolia</span> has more</li>
                            <li data-aos="zoom-out" data-aos-delay="900">than <span>500 bird species</span>?</li>
                        </ul>
                        <p data-aos="zoom-out" data-aos-delay="1200">With beautiful untouched nature comes exotic wildlife. In particular, Mongolia is especially known for hundreds of migratory and rare birds. Thus, bird watching has become a popular attraction over the years. Visitors and bird enthusiasts will be able to see all sorts of species of falcons, eagles, owls, ducks, swans, buntings and many others.</p>
                        <p data-aos="zoom-out" data-aos-delay="1500">In November 2012, the Saker Falcon was recognized as our national bird. A fascinating creature indeed.</p>
                        <div class="box-bohemian" :class="{'bohemian-hide':bohemianHide}">
                            <img :src="bohemian" alt="bohemian">
                            <p class="title">Bohemian Waxing</p>
                            <p class="lorem">Explore Mongolia for birding. See which species we have and where to see them best.</p>
                            <router-link class="btn btn-bohemian btn-block" :to="{ name: 'themes', params: { nametravel: 'bird-watching' }}">
                                See Birds in Mongolia
                            </router-link>
                        </div>
                        <img :src="imgScrollDown4" class="imgScrollDown4" alt="imgScrollDown4" @click="slide4">
                    </div>
                </div>
            </section>
            <section id="five" class="section-box">
                <div id="slide-five" class="slide five">
                    <div class="bg-slide5-1" :class="{'active-slide':activeSlide4}"></div>
                    <div class="bg-slide5-2" :class="{'active-slide':activeSlide5}"></div>
                    <div class="description">
                        <ul>
                            <li data-aos="zoom-out" data-aos-delay="300">Did you know</li>
                            <li data-aos="zoom-out" data-aos-delay="600">that in <span>Mongolia</span> the <span>Milky Way’s stars</span></li>
                            <li data-aos="zoom-out" data-aos-delay="900">appear <span>closer and clearer than</span></li>
                            <li data-aos="zoom-out" data-aos-delay="1200"><span>anywhere</span> else in the world?</li>
                        </ul>
                        <div class="detail">
                            <p data-aos="zoom-out" data-aos-delay="1500">Mongolia is just as beautiful at night as it is during the day. Imagine camping in a vast open space, cuddled in your warm blanket with a glass of milk in your hand. At night, look above and you’ll be mesmerized by the sky and Milky Way stars. They appear so close and clear, you would not believe it.</p>
                            <p data-aos="zoom-out" data-aos-delay="1800">If stargazing is your thing, then we invite you to Mongolia as an unrivalled destination.</p>
                        </div>
                        <div class="box-camping" :class="{'camping-hide':campingHide}">
                            <img :src="camping" alt="camping">
                            <p class="title">Ger Camping Experience</p>
                            <p class="lorem">Gers are the traditional homes of many Mongolians. It is perfect for a nomadic lifestyle.</p>
                            <router-link class="btn btn-camping btn-block" :to="{ name: 'themes', params: { nametravel: 'adventure' }}">
                                Discover Adventure Experiences
                            </router-link>
                        </div>
                    </div>
                    <div class="ig" :class="{'show-ig-five':showIgFive}">
                        <ImagesBoard :perPage="12" :rowHeight="200" tag="adventure" />
                    </div>
                    <img :src="imgScrollDown5" class="imgScrollDown5" alt="imgScrollDown5" @click="slide5">
                </div>
            </section>
            <section id="six" class="section-box">
                <div id="slide-six" class="slide six">
                    <div class="bg-slide6-1" :class="{'active-slide':activeSlide5}"></div>
                    <div class="bg-slide6-2" :class="{'active-slide':activeSlide6}"></div>
                    <div class="ig">
                        <div class="list-ig" :class="{'show-ig-six':showIgSix}">
                            <ImagesBoard :perPage="12" :rowHeight="200" tag="festivals" />
                        </div>
                    </div>
                    <div class="description">
                        <ul>
                            <li data-aos="zoom-out" data-aos-delay="300">Did you know</li>
                            <li data-aos="zoom-out" data-aos-delay="600"><span>Mongolia</span> has</li>
                            <li data-aos="zoom-out" data-aos-delay="900"><span>a horseracing</span></li>
                            <li data-aos="zoom-out" data-aos-delay="1200"><span>festival</span>?</li>
                        </ul>

                        <p data-aos="zoom-out" data-aos-delay="1500">As part of our nomadic culture, most people learn to ride a horse at a young age. To celebrate cultural heritage, each year an exciting but challenging horse race festival is prepared. Without a doubt, jockeys and horses go through intense training leading up to the event.</p>
                        <p data-aos="zoom-out" data-aos-delay="1800">It is one of three games that take place during the Naadam festival. Other games are wrestling and archery. </p>
                        <p data-aos="zoom-out" data-aos-delay="2100">Typically held from July 11 – 15, Naadam festival brings together communities and villages. However, some villages prefer to do it on their own at another time. So, if you miss it during July, there’s always another chance to see it in another part of the country.</p>
                        <p data-aos="zoom-out" data-aos-delay="2400">Naadam festival is more than just a sporting event, it’s considered our national holiday. So, come – travel to Mongolia and experience this exciting festival for yourself.</p>

                        <div class="box-festival" :class="{'festival-hide':festivalHide}">
                            <img :src="festival" alt="festival">
                            <p class="title">NAADAM Festival</p>
                            <p class="lorem">Mongolians know how to celebrate! Find out more about our many events and festivals. </p>
                            <router-link class="btn btn-festival btn-block" :to="{ name: 'themes', params: { nametravel: 'festivals' }}">
                                Join the Mongolian Festivals
                            </router-link>
                        </div>

                        <img :src="imgScrollDown6" class="imgScrollDown6" alt="imgScrollDown6" @click="slide6">
                    </div>
                </div>
            </section>
            <section id="seven" class="section-box">
                <div id="slide-seven" class="slide seven">
                    <div class="bg-slide7-1" :class="{'active-slide':activeSlide6}"></div>
                    <div class="bg-slide7-2" :class="{'active-slide':activeSlide7}"></div>
                    <div class="description">
                        <ul>
                            <li data-aos="zoom-out" data-aos-delay="300">Did you know</li>
                            <li data-aos="zoom-out" data-aos-delay="600"><span>Mongolia</span> has more</li>
                            <li data-aos="zoom-out" data-aos-delay="900">than <span>800 buddhist</span></li>
                            <li data-aos="zoom-out" data-aos-delay="1200"><span>monasteries</span>?</li>
                        </ul>

                        <p data-aos="zoom-out" data-aos-delay="1500">We have always practised Shamanism throughout history, but after the 16th century, Tibetan Buddhism gained more popularity in Mongolia. Since then, despite communism and anti-religious campaigns, we still have hundreds of Buddhist monasteries that highlight our culture, heritage and religious traditions. </p>
                        <p data-aos="zoom-out" data-aos-delay="1800">These magnificent monasteries and temples hold wonder and magnificence in the eyes of the locals and visitors alike.</p>
                        
                        <div class="box-monastery" :class="{'monastery-hide':monasteryHide}">
                            <img :src="monastery" alt="monastery">
                            <p class="title">Buddhist Tourism</p>
                            <p class="lorem">Mongolia is a land of wonder. Explore our monasteries, festivals, and sights.</p>
                            <router-link class="btn btn-monastery btn-block" :to="{ name: 'themes', params: { nametravel: 'buddhist-tourism' }}">
                                Explore Buddhism in Mongolia
                            </router-link>
                        </div>

                        <img :src="imgScrollDown7" class="imgScrollDown7" alt="imgScrollDown7"  @click="slide7">
                    </div>
                    <div class="ig">
                        <div class="list-ig" :class="{'show-ig-seven':showIgSeven}">
                            <ImagesBoard :perPage="12" :rowHeight="200" tag="buddhist-tourism" />
                        </div>
                    </div>
                </div>
            </section>
            <section id="eight" class="section-box">
                <div id="slide-eight" class="slide eight">
                    <div class="bg-slide8-1" :class="{'active-slide':activeSlide7}"></div>
                    <div class="description">
                        <ul>
                            <li data-aos="zoom-out" data-aos-delay="300">First Time</li>
                            <li data-aos="zoom-out" data-aos-delay="600">Planning</li>
                        </ul>
                        <p data-aos="zoom-out" data-aos-delay="900">Mongolia isn’t just a destination you visit to tick off a bunch of bucket list items. It’s a place you go to just be. For first time visitors, as with any travel planning, it is important to know as much about the country beforehand.</p>
                        <p data-aos="zoom-out" data-aos-delay="1200">Outside of the cities, where the real culture and adventure lies, travel is rugged and immersive. Expect to stay in local camps (Gers), be on bumpy roads for long hours and away from the modern conveniences of civilization. If you are open-minded and adventurous, there is so much the country has to offer with its culture, history and nature.</p>
                    </div>
                    <div class="getting">
                        <div class="box-getting mb-4" data-aos="zoom-out" data-aos-anchor-placement="top-bottom" data-aos-delay="1500">
                            <p class="title">Getting to Mongolia</p>
                            <p class="descript">Direct flights are available from countries such as China, Russia, Germany, Korea, Hong Kong, and Turkey. You can also visit Mongolia by train via Trans-Mongolian Line, which is part of the Trans-Siberian Railway. If you’re looking for an adventure and depending on your nationality, you can even drive to Mongolia from Russia or China.</p>
                            <button class="btn btn-getting mr-2">Visa</button>
                            <button class="btn btn-getting">Transport</button>
                        </div>

                        <div class="box-getting" data-aos="zoom-out" data-aos-anchor-placement="top-bottom" data-aos-delay="1800">
                            <p class="title">Travel around</p>
                            <p class="descript">While you can get around most of Mongolia by air, the country is still vast and requires a lot of driving to get to places. Getting to distant places and worthwhile destinations require a lot of patience and travel know-how. However, there are plenty of tour operators and logistics companies that are able to help visitors get around the country.</p>
                            <button class="btn btn-getting">Transport</button>
                        </div>
                        <router-link to="/" class="btnHome">
                            <img :src="btnHome"  alt="btnHome">
                        </router-link>
                    </div>
                    <div class="zone">
                        <div class="box-zone">
                            <div class="detail-zone" data-aos="zoom-out" data-aos-delay="2100">
                                <img :src="zone1" class="img-zone" alt="zone1">
                                <div>Continent</div>
                                <div>Asia (East)</div>
                                <router-link :to="{ name: 'map', query: { ac: 1 }}" class="btn btn-zone">World Map</router-link>
                            </div>
                            <div class="detail-zone" data-aos="zoom-out" data-aos-delay="2400">
                                <img :src="zone2" class="img-zone" alt="zone2">
                                <div>Climate</div>
                                <div>Desert / Continental</div>
                                <a href="https://weather.com/weather/today/l/MGXX0003:1:MG" class="btn btn-zone btn-long" target="_blank" rel="noopener noreferrer">Weather Forecast</a>
                            </div>
                            <div class="detail-zone" data-aos="zoom-out" data-aos-delay="2700">
                                <img :src="zone3" class="img-zone" alt="zone3">
                                <div>Language</div>
                                <div>Mongolian / Chinese</div>
                                <button class="btn btn-zone">Learn Basic</button>
                            </div>
                            <div class="detail-zone" data-aos="zoom-out" data-aos-delay="3000">
                                <img :src="zone4" class="img-zone" alt="zone4">
                                <div>Currency</div>
                                <div>Tugrik (Tögrög)</div>
                                <a href="https://www.xe.com/currencyconverter/convert/?Amount=1&From=USD&To=MNT" class="btn btn-zone" target="_blank" rel="noopener noreferrer">Calculate</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
		<NavrightHome />
	</div>
</template>

<script>
import { TweenLite } from "gsap/all";
import NavrightHome from '@/components/NavrightHome';
import NavOther from '@/components/NavOther';
import ImagesBoard from '@/components/ImagesBoard';
import mapZoom from '../assets/img/map-zoom.png';
import explore from '../assets/img/explore.png';
import historical from '../assets/img/historical.png';
import bohemian from '../assets/img/bohemian.jpg';
import camping from '../assets/img/camping.jpg';
import festival from '../assets/img/festival.jpg';
import monastery from '../assets/img/monastery.jpg';
import sd from '../assets/img/scrolldown.png';
import sd2 from '../assets/img/scrolldown2.png';
import sd3 from '../assets/img/scrolldown3.png';
import sd4 from '../assets/img/scrolldown4.png';
import sd5 from '../assets/img/scrolldown5.png';
import sd6 from '../assets/img/scrolldown6.png';
import sd7 from '../assets/img/scrolldown7.png';
import zone1 from '../assets/img/zone1.png';
import zone2 from '../assets/img/zone2.png';
import zone3 from '../assets/img/zone3.png';
import zone4 from '../assets/img/zone4.png';
import coming from '../assets/img/coming-soon.png';
import btnHome from '../assets/img/btn-home.png';

export default {
    name: 'FirstTimeTraveler',
    components : {
        NavrightHome,
        NavOther,
        ImagesBoard
    },
    data(){
        return {
            inZoomActive: false,
            active: false,
            del: false,
            show: false,
            showIG: false,
            sb2Hide: true,
            isHide: false,
            showIgFour: false,
            bohemianHide: false,
            showIgFive: false,
            campingHide: false,
            showIgSix: false,
            festivalHide: false,
            showIgSeven: false,
            monasteryHide: false,
            activeSlide1: false,
            activeSlide2: false,
            activeSlide3: false,
            activeSlide4: false,
            activeSlide5: false,
            activeSlide6: false,
            activeSlide7: false,
            mapZoom: mapZoom,
            imgScrollDown: sd,
            imgScrollDown2: sd2,
            imgScrollDown3: sd3,
            imgScrollDown4: sd4,
            imgScrollDown5: sd5,
            imgScrollDown6: sd6,
            imgScrollDown7: sd7,
            explore: explore,
            historical: historical,
            bohemian: bohemian,
            camping: camping,
            festival: festival,
            monastery: monastery,
            zone1: zone1,
            zone2: zone2,
            zone3: zone3,
            zone4: zone4,
            comingSoon: coming,
            isComing : "",
            myWindowHeight: (window.innerHeight * 2),
            clickSlide: 1,
            btnHome : btnHome,
            timer : "",
            cntScroll: 0
        };
    },
    mounted() {
        document.body.style.overflow = 'hidden';
        this.scrollEvent();
        import('aos').then(AOS => AOS.init());
        let slideshow = document.getElementById("FirstTimeTraveler");
        let mousewheelevt=(/Firefox/i.test(navigator.userAgent))? "DOMMouseScroll" : "mousewheel"
        document.addEventListener("keydown", this.onKeyDown);

        if (slideshow.attachEvent) //if IE (and Opera depending on user setting)
            slideshow.attachEvent("on"+mousewheelevt, this.onMouseWheel)
        else if (slideshow.addEventListener) //WC3 browsers
            slideshow.addEventListener(mousewheelevt, this.onMouseWheel, false)
    },
    destroyed() {
        document.body.style.overflow = 'initial';
    },
    methods: {
        onMouseWheel(event){
            var e = window.event || event; // old IE support
            var delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));
            var vm = this;
            window.clearTimeout(vm.timer);
            
            if(delta < 0){
                vm.timer = window.setTimeout(function(){
                    vm.cntScroll += 1
                    if (vm.cntScroll>16) {
                        vm.cntScroll = 16
                    }
                    vm.nextSlide(vm.cntScroll);
                },200);
            }
            else if(delta > 0){
                vm.timer = window.setTimeout(function(){
                    vm.cntScroll -= 1;
                    if (vm.cntScroll<0) {
                        vm.cntScroll = 0
                    }
                    vm.backSlide(vm.cntScroll);
                    
                },200);
            }
            event.preventDefault();
        },
        scrollEvent() {
            var vm = this;
            let dataDuration = '200%';
            
            const scene = new this.$scrollmagic.Scene({
                triggerElement: '#one',
                triggerHook: 'onLeave',
                duration: dataDuration
            })
            .setPin('.first')
            .on("progress", function (event) {
                vm.inZoomActive = (event.progress >= 0.05)? true : false ;
                vm.active = (event.progress >= 0.5)? true : false ;
            });
            this.$ksvuescr.$emit('addScene', 'pinContainerScene', scene);

            const scene2 = new this.$scrollmagic.Scene({
                triggerElement: '#two',
                triggerHook: 'onLeave',
                duration: dataDuration
            })
            .setPin('.two')
            .on("progress", function (event) {
                vm.del = (event.progress >= 0.3)? true : false ;
                vm.sb2Hide = (event.progress >= 0.3)? false : true ;
                vm.show = (event.progress > 0.3 && event.progress < 0.6)? true : false ;
                vm.showIG = (event.progress >= 0.6)? true : false ;
                vm.clickSlide = (event.progress >= 0.6)? 2 : 1 ;
            });
            this.$ksvuescr.$emit('addScene', 'pinContainerScene', scene2);

            const scene3 = new this.$scrollmagic.Scene({
                triggerElement: '#three',
                triggerHook: 'onLeave',
                duration: dataDuration
            })
            .setPin('.three')
            .on("progress", function (event) {
                vm.isHide = (event.progress >= 0.3)? true : false ;
                vm.clickSlide = (event.progress >= 0.5)? 3 : 2 ;
            });
            this.$ksvuescr.$emit('addScene', 'pinContainerScene', scene3);

            const scene4 = new this.$scrollmagic.Scene({
                triggerElement: '#four',
                triggerHook: 'onLeave',
                duration: dataDuration
            })
            .setPin('.four')
            .on("progress", function (event) {
                vm.showIgFour = (event.progress >= 0.3)? true : false ;
                vm.bohemianHide = (event.progress >= 0.3)? true : false ;
                vm.clickSlide = (event.progress >= 0.3)? 4 : 3 ;
            });
            this.$ksvuescr.$emit('addScene', 'pinContainerScene', scene4);

            const scene5 = new this.$scrollmagic.Scene({
                triggerElement: '#five',
                triggerHook: 'onLeave',
                duration: dataDuration
            })
            .setPin('.five')
            .on("progress", function (event) {
                vm.showIgFive = (event.progress >= 0.3)? true : false ;
                vm.campingHide = (event.progress >= 0.3)? true : false ;
                vm.clickSlide = (event.progress >= 0.3)? 5 : 4 ;
            });
            this.$ksvuescr.$emit('addScene', 'pinContainerScene', scene5);

            const scene6 = new this.$scrollmagic.Scene({
                triggerElement: '#six',
                triggerHook: 'onLeave',
                duration: dataDuration
            })
            .setPin('.six')
            .on("progress", function (event) {
                vm.showIgSix = (event.progress >= 0.3)? true : false ;
                vm.festivalHide = (event.progress >= 0.3)? true : false ;
                vm.clickSlide = (event.progress >= 0.3)? 6 : 5 ;
            });
            this.$ksvuescr.$emit('addScene', 'pinContainerScene', scene6);

            const scene7 = new this.$scrollmagic.Scene({
                triggerElement: '#seven',
                triggerHook: 'onLeave',
                duration: dataDuration
            })
            .setPin('.seven')
            .on("progress", function (event) {
                vm.showIgSeven = (event.progress >= 0.3)? true : false ;
                vm.monasteryHide = (event.progress >= 0.3)? true : false ;
                vm.clickSlide = (event.progress >= 0.3)? 7 : 6 ;
            });
            this.$ksvuescr.$emit('addScene', 'pinContainerScene', scene7);
        },
        nextSlide(slider) {
            var vm = this;
            if (slider == 0) {
                vm.toTop()
            }
            if (slider == 1) {
                vm.inZoom()
            }
            if (slider == 2) {
                vm.showWhatDoYou()
            }
            if (slider == 3) {
                vm.nextSlide2()
            }
            if (slider == 4) {
                vm.openCover()
            }
            if (slider == 5) {
                vm.openIG()
            }
            if (slider == 6) {
                vm.openIG()
            }
            if (slider == 7) {
                vm.slide3()
            }
            if (slider == 8) {
                vm.slide3()
            }
            if (slider == 9) {
                vm.slide4()
            }
            if (slider == 10) {
                vm.slide4()
            }
            if (slider == 11) {
                vm.slide5()
            }
            if (slider == 12) {
                vm.slide5()
            }
            if (slider == 13) {
                vm.slide6()
            }
            if (slider == 14) {
                vm.slide6()
            }
            if (slider == 15) {
                vm.slide7()
            }
            if (slider == 16) {
                vm.slide7()
            }
        },
        backSlide(slider) {
            var vm = this;
            if (slider == 0) {
                vm.toTop()
            }
            if (slider == 1) {
                vm.inZoom()
            }
            if (slider == 2) {
                let myScroll = (this.myWindowHeight * 0.5);
                TweenLite.to(window, 2.5, {scrollTo:myScroll});
                this.activeSlide1 = false;
            }
            if (slider == 3) {
                vm.nextSlide2()
            }
            if (slider == 4) {
                vm.openCover()
            }
            if (slider == 5) {
                let myScroll = (this.myWindowHeight * 2.3);
                TweenLite.to(window, 1.3, {scrollTo:myScroll});
                this.activeSlide2 = false;
            }
            if (slider == 6) {
                let myScroll = (this.myWindowHeight * 3);
                TweenLite.to(window, .6, {scrollTo:myScroll});
            }
            if (slider == 7) {
                let myScroll = (this.myWindowHeight * 3.5);
                TweenLite.to(window, 2.5, {scrollTo:myScroll});
                this.activeSlide3 = false;
            }
            if (slider == 8) {
                let myScroll = (this.myWindowHeight * 4.5);
                TweenLite.to(window, .6, {scrollTo:myScroll});
                this.bohemianHide = true;
            }
            if (slider == 9) {
                let myScroll = (this.myWindowHeight * 5);
                TweenLite.to(window, 2.3, {scrollTo:myScroll});
                this.activeSlide4 = false;
            }
            if (slider == 10) {
                let myScroll = (this.myWindowHeight * 6);
                TweenLite.to(window, .6, {scrollTo:myScroll});
            }
            if (slider == 11) {
                let myScroll = (this.myWindowHeight * 6.5);
                TweenLite.to(window, 2.3, {scrollTo:myScroll});
                this.activeSlide5 = false;
            }
            if (slider == 12) {
                let myScroll = (this.myWindowHeight * 7.5);
                TweenLite.to(window, .6, {scrollTo:myScroll});
            }
            if (slider == 13) {
                let myScroll = (this.myWindowHeight * 8);
                TweenLite.to(window, 2.3, {scrollTo:myScroll});
                this.activeSlide6 = false;
            }
            if (slider == 14) {
                let myScroll = (this.myWindowHeight * 9);
                TweenLite.to(window, .6, {scrollTo:myScroll});
            }
            if (slider == 15) {
                let myScroll = (this.myWindowHeight * 9.5);
                TweenLite.to(window, 2.3, {scrollTo:myScroll});
                this.activeSlide7 = false;
            }
        },
        toTop() {
            let myScroll = (this.myWindowHeight * 0);
            TweenLite.to(window, .6, {scrollTo:0});
        },
        inZoom() {
            let myScroll = (this.myWindowHeight * 0.1);
            TweenLite.to(window, .6, {scrollTo:myScroll});
            this.cntScroll = 1;
        },
        showWhatDoYou() {
            let myScroll = (this.myWindowHeight * 0.5);
            TweenLite.to(window, .6, {scrollTo:myScroll});
            this.cntScroll = 2;
        },
        nextSlide2() {
            let myScroll = (this.myWindowHeight * 1.5);
            TweenLite.to(window, 1.3, {scrollTo:myScroll});
            this.activeSlide1 = true;
            this.cntScroll = 3;
        },
        openCover() {
            let myScroll = (this.myWindowHeight * 2);
            TweenLite.to(window, .6, {scrollTo:myScroll});
            this.cntScroll = 4;
        },
        openIG() {
            if (this.clickSlide == 1) {
                let myScroll = (this.myWindowHeight * 2.3);
                TweenLite.to(window, .6, {scrollTo:myScroll});
                this.cntScroll = 5;
            } else {
                let myScroll = (this.myWindowHeight * 3);
                TweenLite.to(window, 1.3, {scrollTo:myScroll});
                this.activeSlide2 = true;
                this.cntScroll = 6;
            }
        },
        slide3() {
            if (this.clickSlide == 2) {
                let myScroll = (this.myWindowHeight * 3.5);
                TweenLite.to(window, .6, {scrollTo:myScroll});
                this.cntScroll = 7;
            } else {
                let myScroll = (this.myWindowHeight * 4.5);
                TweenLite.to(window, 1.3, {scrollTo:myScroll});
                this.activeSlide3 = true;
                this.cntScroll = 8;
            }
        },
        slide4() {
            if (this.clickSlide == 3) {
                let myScroll = (this.myWindowHeight * 5);
                TweenLite.to(window, .6, {scrollTo:myScroll});
                this.cntScroll = 9;
            } else {
                let myScroll = (this.myWindowHeight * 6);
                TweenLite.to(window, 1.3, {scrollTo:myScroll});
                this.activeSlide4 = true;
                this.cntScroll = 10;
            }
        },
        slide5() {
            if (this.clickSlide == 4) {
                let myScroll = (this.myWindowHeight * 6.5);
                TweenLite.to(window, .6, {scrollTo:myScroll});
                this.cntScroll = 11;
            } else {
                let myScroll = (this.myWindowHeight * 7.5);
                TweenLite.to(window, 1.3, {scrollTo:myScroll});
                this.activeSlide5 = true;
                this.cntScroll = 12;
            }
        },
        slide6() {
            if (this.clickSlide == 5) {
                let myScroll = (this.myWindowHeight * 8);
                TweenLite.to(window, .6, {scrollTo:myScroll});
                this.cntScroll = 13;
            } else {
                let myScroll = (this.myWindowHeight * 9);
                TweenLite.to(window, 1.3, {scrollTo:myScroll});
                this.activeSlide6 = true;
                this.cntScroll = 14;
            }
        },
        slide7() {
            if (this.clickSlide == 6) {
                let myScroll = (this.myWindowHeight * 9.5);
                TweenLite.to(window, .8, {scrollTo:myScroll});
                this.cntScroll = 15;
            } else {
                TweenLite.to(window, 1, {scrollTo:'max'});
                this.activeSlide7 = true;
                this.cntScroll = 16;
            }
        },
        clickBtn(btnName) {
            this.isComing = btnName;
            setTimeout(() => {
                this.isComing = "";
            }, 1000)
        }
    }

}
</script>


<style lang="scss">
@font-face {
    font-family: 'James Fajardo';
    src: url('../assets/fonts/JamesFajardo.eot');
    src: url('../assets/fonts/JamesFajardo.eot?#iefix') format('embedded-opentype'),
        url('../assets/fonts/JamesFajardo.woff2') format('woff2'),
        url('../assets/fonts/JamesFajardo.woff') format('woff'),
        url('../assets/fonts/JamesFajardo.svg#JamesFajardo') format('svg');
    font-weight: normal;
    font-style: normal;
}

.FirstTimeTraveler {
    .slides-container {
        overflow-x: hidden;

        .section-box {
            height: calc(100% * 2);
        }

        .slide {
            height: 100vh;
            .btn {
                position: relative;
            }

            &.first {
                display: flex;
                flex-wrap: wrap;
                padding-top: 102px;
                .ig {
                    width: 45%;
                    height: 100%;
                    background-color: #666;
                    overflow: hidden;
                }   

                .detail {
                    width: 55%;
                    height: 100%;
                    position: relative;

                    .title,.welcome,.description>p {
                        opacity: 0;
                    }

                    .title {
                        color: red;
                    }

                    .welcome {
                        font-weight: bold;

                        span {
                            color: red;
                        }
                    }

                    .map-zoom {
                        cursor: pointer;
                        position: relative;
                        opacity: 0;
                        width: 205px;
                        height: 205px;
                        margin: 0 auto;
                        border: 5px solid #F4F4F4;
                        border-radius: 50%;
                        transition: .2s ease-in;
                        img {
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            transform: translate(-48%, -45%);
                        }
                    }
                }

                .what-do-you {
                    position: absolute;
                    top: 0;
                    padding-top: 102px;
                    width: 100%;
                    height: 100vh;
                    background-color: #FFFFFF;
                    z-index: 0;
                    opacity: 0;
                    transition: .6s ease-in-out;

                    .text-what-do-you {
                        padding-top: 60px;
                        padding-left: 557px;
                        padding-bottom: 130px;

                        ul {
                            position: relative;
                            left: 40%;
                            transform: translate(-50%);
                            list-style: none;
                            padding: 0;
                            margin: 0;
                            li {
                                font-size: 60px;
                                line-height: 60px;
                                font-weight: bold;
                                opacity: 0;
                                &:nth-child(odd) {
                                    color: #E13036;
                                }
                            }
                        }
                    }
                }

                .zoom {
                    cursor: pointer;
                    position: absolute;
                    z-index: 1;
                    opacity: 1;
                    top: 102px;
                    right: 0;
                    width: 100%;
                    height: calc(100vh - 102px);
                    background-image: url('../assets/img/bg-map.png');
                    background-repeat: no-repeat;
                    background-attachment: fixed;
                    background-position: center center;
                    background-size: cover;
                    overflow: hidden;
                    transition: .5s cubic-bezier(.77, 0, .175, 1);
                    

                    .bg-map {
                        background: url('../assets/img/map.png') no-repeat;
                        background-size: 100%;
                        width: 1200px;
                        height: 780px;
                        position: relative;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        transition: .5s cubic-bezier(.77, 0, .175, 1);

                        #circle-map {
                            position: absolute;
                            top: 155px;
                            right: 150px;
                        }

                        .name-mongolia {
                            font-family: 'James Fajardo';
                            font-size: 200px;
                            position: absolute;
                            top: 40%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                        }
                    }

                    

                    #scrolldown-map {
                        position: absolute;
                        bottom: 30px;
                        left: 50%;
                        transform: translateX(-45%);  
                    }
                }

                .bg-slide {
                    background-color: #E13036;
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    height: 100%;
                    max-height: 0vh;
                    transition: max-height 0.6s linear; 
                    transition-delay: 0.4s;
                    z-index: 6;
                    &.active-slide {
                        transition-delay: 0s;
                        height: 100%;
                        max-height: 100vh;
                    }
                }
                
            } // close .first

            &.two {
                .bg-slide2-1 {
                    background-color: #911457;
                    position: absolute;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    max-height: 100vh;
                    transition: max-height .6s linear; 
                    z-index: 6;
                    &.active-slide {
                        transition-delay: 0.8s;
                        height: 100%;
                        max-height: 0vh;
                    }
                }

                .bg-slide2-2 {
                    background-color: #911457;
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    height: 100%;
                    max-height: 0vh;
                    transition: max-height 0.6s linear; 
                    transition-delay: 0.4s;
                    z-index: 6;
                    &.active-slide {
                        transition-delay: 0s;
                        height: 100%;
                        max-height: 100vh;
                    }
                }

                .detail-two {
                    position: absolute;
                    .description {
                        width: 50%;
                        height: 100vh;
                        margin: 0 auto;
                        padding: 132px 50px 0px 50px;

                        

                        .description-first {
                            list-style: none;
                            padding: 0;
                            
                            li {
                                opacity: 0;
                                font-size: 33px;
                                font-weight: bold;
                                line-height: 33px;
                            }

                            .text-911457 {
                                color: #911457;
                            }
                        }

                        .description-two {
                            padding-right: 150px;
                            p {
                                opacity: 0;
                                font-size: 15px;
                            }

                            .exploreOur {
                                opacity: 0;
                                position: absolute;
                                bottom: 30px;
                                right: calc(200px + 40px);
                                width: 255px;
                                padding: 10px;
                                background-color: #FFFFFF;
                                box-shadow: 0px 1px 5px 1px #999;
                                transition: .3s linear;

                                .exploreOur-img {
                                    img {
                                        max-width: 100%;
                                    }
                                }

                                .exploreOur-title {
                                    font-size: 16px;
                                    font-weight: bold;
                                }

                                .Lorem{
                                    font-size: 12px;
                                }

                                .btn-explore {
                                    background-color: #911457;
                                    border-radius: 0px;
                                    color: #FFFFFF;

                                    .comingSoon {
                                        opacity: 0;
                                        position: absolute;
                                        top: -5px;
                                        right: -185px;
                                        transition: .3s ease-out
                                    }

                                    &.isComing {
                                        .comingSoon {
                                            opacity: 1;
                                            transition: .3s ease-in
                                        }
                                    }
                                }

                                &.show {
                                    opacity: 1;
                                    transition-delay: .4s;
                                }
                            }
                        }

                        &.active {
                            .description-first {
                                li {
                                    opacity: 1;
                                }
                            }

                            .description-two {
                                p {
                                    opacity: 1;
                                }
                            }
                        }
                    }

                    .img-cover {
                        position: absolute;
                        top: 0;
                        left: 50%;
                        transform: translate(-50%);
                        width: 50%;
                        height: 100vh;
                        transition: .6s linear;

                        .img-left {
                            position: absolute;
                            top: 0;
                            left: 0;
                            background-image: url('../assets/img/imgleft.png');
                            background-repeat: no-repeat;
                            background-size: cover;
                            background-position-x: 100%;
                            height: 100vh;
                            width: 50%;
                            transition: .3s linear;
                        }

                        .img-right {
                            position: absolute;
                            top: 0;
                            right: 0;
                            background-image: url('../assets/img/imgright.png');
                            background-repeat: no-repeat;
                            background-size: cover;
                            height: 100vh;
                            width: 50%;
                            transition: .3s linear;
                        }

                        .ig {
                            opacity: 0;
                            padding-top: 102px;
                            width: 100%;
                            height: 100%;
                            // background-color: #FFFFFF;
                            background-color: #999999;
                            transition: .3s linear;
                            overflow: hidden;

                            &.show {
                                opacity: 1;
                                transition-delay: .4s;
                            }

                        }

                        &.cover-active {
                            .img-left {
                                left: -50%;
                            }

                            .img-right {
                                right: calc(-50% + 40px);
                            }
                        }
                    }

                    .img-scroll2 {
                        cursor: pointer;
                        position: absolute;
                        bottom: 10px;
                        left: 50%;
                        transform: translate(-50%);

                        &.del,&.sb2Hide {
                            display: none;
                        }
                    }
                    
                }
            } // close two

            &.three {
                display: flex;
                .bg-slide3-1 {
                    background-color: #10523B;
                    position: absolute;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    max-height: 100vh;
                    transition: max-height .6s linear; 
                    z-index: 6;
                    &.active-slide {
                        transition-delay: 0.8s;
                        height: 100%;
                        max-height: 0vh;
                    }
                }

                .bg-slide3-2 {
                    background-color: #10523B;
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    height: 100%;
                    max-height: 0vh;
                    transition: max-height .6s linear; 
                    transition-delay: 0.4s;
                    z-index: 6;
                    &.active-slide {
                        transition-delay: 0s;
                        height: 100%;
                        max-height: 100vh;
                    }
                }

                .description {
                    padding: 122px 100px 0 30px;
                    width: 40%;
                    height: 100vh;
                    ul {
                        list-style: none;
                        padding: 0;
                        li {
                            font-weight: bold;
                            font-size: 33px;
                            line-height: 33px;

                            .color-li {
                                color: #10523B;
                            }
                        }
                    }

                    p {
                        font-size: 12px;
                    }

                    img {
                        cursor: pointer;
                        position: relative;
                        left: 50%;
                        transform: translate(-50%);
                        z-index: 1;
                    }
                }

                .img-three {
                    width: 60%;
                    height: 100vh;
                    background-image: url('../assets/img/background-three.png');
                    background-size: cover;

                    .box-historical {
                        opacity: 1;
                        position: absolute;
                        bottom: 30px;
                        left: 450px;
                        width: 200px;
                        padding: 10px;
                        background-color: #FFFFFF;
                        box-shadow: 0px 1px 5px 1px #999;
                        transition: .2s linear;
                        transition-delay: .2s;

                        img {
                            width: 100%;
                        }

                        .title {
                            font-size: 12px;
                            font-weight: bold;
                        }

                        .lorem {
                            font-size: 10px;
                        }

                        .btn-historical {
                            background-color: #10523B;
                            border-radius: 0px;
                            color: #FFFFFF;
                            font-size: 12px;

                            .comingSoon {
                                opacity: 0;
                                position: absolute;
                                top: -5px;
                                right: -100%;
                                transition: .3s ease-out
                            }

                            &.isComing {
                                .comingSoon {
                                    opacity: 1;
                                    transition: .3s ease-in
                                }
                            }
                        }

                        &.ishide {
                            opacity: 0;
                            left: 0;
                            transition-delay: 0s;
                        }
                    }

                    .ig {
                        opacity: 0;
                        padding-top: 102px;
                        width: 100%;
                        height: 100%;
                        background-color: #FFFFFF;
                        transition: .2s linear;
                        overflow: hidden;

                        &.show-box-three {
                            opacity: 1;
                            transition-delay: .2s;
                        }
                    }
                    
                }
            } // close three

            &.four {
                position: relative;
                display: flex;
                background-image: url('../assets/img/background-four.jpg');
                background-size: cover;
                background-repeat: no-repeat;
                .bg-slide4-1 {
                    background-color: #228B5B;
                    position: absolute;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    max-height: 100vh;
                    transition: max-height .6s linear; 
                    z-index: 6;
                    &.active-slide {
                        transition-delay: 0.8s;
                        height: 100%;
                        max-height: 0vh;
                    }
                }

                .bg-slide4-2 {
                    background-color: #228B5B;
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    height: 100%;
                    max-height: 0vh;
                    transition: max-height .6s linear; 
                    transition-delay: 0.4s;
                    z-index: 6;
                    &.active-slide {
                        transition-delay: 0s;
                        height: 100%;
                        max-height: 100vh;
                    }
                }

                .ig {
                    position: absolute;
                    padding-top: 102px;
                    left: -100%;
                    min-width: 500px;
                    width: 25%;
                    height: 100%;
                    background-color: rgba(112, 112, 112, 0.6);
                    transition: .5s linear;
                    overflow: hidden;

                    &.show-ig-four {
                        left: 0;
                    }
                }

                .description {
                    width: 50%;
                    height: 100vh;
                    min-width: 600px;
                    position: absolute;
                    right: 40px;
                    padding-top: 132px;
                    padding-left: 50px;
                    padding-right: 50px;
                    ul {
                        list-style: none;
                        padding: 0;
                        li {
                            font-weight: bold;
                            font-size: 30px;
                            line-height: 35px;
                            color: #FFFFFF;
                            span {
                                color: #228B5B;
                            }
                        }
                    }

                    p {
                        color: #FFFFFF;
                        font-size: 12px;
                    }

                    .imgScrollDown4 {
                        cursor: pointer;
                        position: absolute;
                        bottom: 10px;
                        left: 50%;
                        transform: translate(-50%);
                    }

                    .box-bohemian {
                        opacity: 1;
                        position: absolute;
                        bottom: 10px;
                        left: 50px;
                        width: 200px;
                        padding: 10px;
                        background-color: #FFFFFF;
                        box-shadow: 0px 1px 5px 1px #999;
                        transition: .2s linear;
                        transition-delay: .2s;
                        
                        img {
                            width: 100%;
                        }

                        .title {
                            font-size: 12px;
                            font-weight: bold;
                            color: #000;
                        }

                        .lorem {
                            font-size: 10px;
                            color: #000;
                        }

                        .btn-bohemian {
                            background-color: #10523B;
                            font-size: 10px;
                            border-radius: 0px;
                            color: #FFFFFF;

                            .comingSoon {
                                opacity: 0;
                                position: absolute;
                                top: -5px;
                                right: -100%;
                                transition: .3s ease-out
                            }

                            &.isComing {
                                .comingSoon {
                                    opacity: 1;
                                    transition: .3s ease-in
                                }
                            }
                        }

                        &.bohemian-hide {
                            opacity: 0;
                        }
                    }
                }
            } // close four

            &.five {
                background-image: url('../assets/img/background-five.jpg');
                background-repeat: no-repeat;
                background-size: cover;

                .bg-slide5-1 {
                    background-color: #340A4E;
                    position: absolute;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    max-height: 100vh;
                    transition: max-height .6s linear; 
                    z-index: 6;
                    &.active-slide {
                        transition-delay: 0.8s;
                        height: 100%;
                        max-height: 0vh;
                    }
                }

                .bg-slide5-2 {
                    background-color: #340A4E;
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    height: 100%;
                    max-height: 0vh;
                    transition: max-height .6s linear; 
                    transition-delay: 0.4s;
                    z-index: 6;
                    &.active-slide {
                        transition-delay: 0s;
                        height: 100%;
                        max-height: 100vh;
                    }
                }

                .description {
                    height: 100%;
                    padding: 132px 150px 0 110px;

                    ul {
                        list-style: none;
                        padding: 0;

                        li {
                            font-size: 30px;
                            font-weight: bold;
                            line-height: 35px;
                            color: #FFFFFF;

                            span {
                                color: #340A4E;
                            }
                        }
                    }
                    .detail {
                        width: 40%;
                        margin-top: 30px;
                        p {
                            color: #FFFFFF;
                            font-size: 12px;
                        }
                    }

                    .box-camping {
                        opacity: 1;
                        position: absolute;
                        top: 162px;
                        right: 194px;
                        width: 230px;
                        padding: 10px;
                        background-color: #FFFFFF;
                        box-shadow: 0px 1px 5px 1px #999;
                        transition: .2s linear;
                        transition-delay: .2s;
                        
                        img {
                            width: 100%;
                        }

                        .title {
                            font-size: 12px;
                            font-weight: bold;
                            color: #000;
                        }

                        .lorem {
                            font-size: 10px;
                            color: #000;
                        }

                        .btn-camping {
                            background-color: #340A4E;
                            border-radius: 0px;
                            color: #FFFFFF;
                            font-size: 10px;

                            .comingSoon {
                                opacity: 0;
                                position: absolute;
                                bottom: -60px;
                                left:0;
                                transition: .3s ease-out
                            }

                            &.isComing {
                                .comingSoon {
                                    opacity: 1;
                                    transition: .3s ease-in
                                }
                            }
                        }

                        &.camping-hide {
                            opacity: 0;
                        }
                    }
                    
                }

                .ig {
                    width: 50%;
                    height: 40%;
                    position: absolute;
                    bottom: -100%;
                    right: 95px;
                    background-color: rgba(112, 112, 112, 0.6);
                    transition: .5s linear;
                    overflow: hidden;

                    &.show-ig-five {
                        bottom: 90px;
                    }
                }

                .imgScrollDown5 {
                    cursor: pointer;
                    position: absolute;
                    bottom: 10px;
                    left: 50%;
                    transform: translate(-50%);
                }
            } // close five

            &.six {
                display: flex;

                .bg-slide6-1 {
                    background-color: #E13036;
                    position: absolute;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    max-height: 100vh;
                    transition: max-height .6s linear; 
                    z-index: 6;
                    &.active-slide {
                        transition-delay: 0.8s;
                        height: 100%;
                        max-height: 0vh;
                    }
                }

                .bg-slide6-2 {
                    background-color: #E13036;
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    height: 100%;
                    max-height: 0vh;
                    transition: max-height .6s linear; 
                    transition-delay: 0.4s;
                    z-index: 6;
                    &.active-slide {
                        transition-delay: 0s;
                        height: 100%;
                        max-height: 100vh;
                    }
                }

                .ig {
                    padding-top: 102px;
                    background: url('../assets/img/background-six.jpg');
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: right;
                    width: 50%;
                    overflow: hidden;
                    

                    .list-ig {
                        opacity: 0;
                        width: 100%;
                        height: 100%;
                        background: rgba(112, 112, 112, 0.6);
                        transition: .5s linear;
                        &.show-ig-six {
                            opacity: 1;
                        }
                    }
                    
                }
                
                .description {
                    width: 50%;
                    padding-top: 137px;
                    padding-left: 50px;
                    padding-right: 80px;
                    position: relative;

                    ul {
                        list-style: none;
                        padding: 0;

                        li {
                            font-size: 30px;
                            font-weight: bold;
                            line-height: 35px;

                            span {
                                color: #E31F25;
                            }
                        }
                    }

                    p {
                        font-size: 12px;
                    }

                    .box-festival {
                        opacity: 1;
                        position: absolute;
                        bottom: 20px;
                        left: -170px;
                        width: 200px;
                        padding: 10px;
                        background-color: #FFFFFF;
                        box-shadow: 0px 1px 5px 1px #999;
                        transition: .3s linear;
                        transition-delay: .2s;
                        
                        img {
                            width: 100%;
                        }

                        .title {
                            font-size: 12px;
                            font-weight: bold;
                            
                            color: #000;
                        }

                        .lorem {
                            font-size: 10px;
                            color: #000;
                        }

                        .btn-festival {
                            background-color: #E13036;
                            border-radius: 0px;
                            color: #FFFFFF;
                            font-size: 10px;

                            .comingSoon {
                                opacity: 0;
                                position: absolute;
                                top: -5px;
                                right: -100%;
                                transition: .3s ease-out
                            }

                            &.isComing {
                                .comingSoon {
                                    opacity: 1;
                                    transition: .3s ease-in
                                }
                            }
                        }

                        &.festival-hide {
                            opacity: 0;
                            left: 0;
                        }
                    }

                    .imgScrollDown6 {
                        cursor: pointer;
                        position: absolute;
                        bottom: 10px;
                        left: 50%;
                        transform: translate(-50%);
                    }
                } 
            } // close six

            &.seven {
                display: flex;

                .description {
                    position: relative;
                    width: 40%;
                    height: 100%;
                    padding: 132px 50px 0px 50px;
                    ul {
                        list-style: none;
                        padding: 0;

                        li {
                            font-size: 30px;
                            font-weight: bold;
                            line-height: 35px;

                            span {
                                color: #D59D04;
                            }
                        }
                    }

                    p {
                        font-size: 12px;
                    }

                    .box-monastery {
                        opacity: 1;
                        position: absolute;
                        bottom: 60px;
                        right: -160px;
                        width: 200px;
                        padding: 10px;
                        background-color: #FFFFFF;
                        box-shadow: 0px 1px 5px 1px #999;
                        transition: .2s linear;
                        transition-delay: .2s;
                        
                        img {
                            width: 100%;
                        }

                        .title {
                            font-size: 12px;
                            font-weight: bold;
                            
                            color: #000;
                        }

                        .lorem {
                            font-size: 10px;
                            color: #000;
                        }

                        .btn-monastery {
                            background-color: #D59D04;
                            border-radius: 0px;
                            color: #FFFFFF;
                            font-size: 10px;
                            z-index: 3;

                            .comingSoon {
                                opacity: 0;
                                position: absolute;
                                top: -5px;
                                right: -100%;
                                transition: .3s ease-out
                            }

                            &.isComing {
                                .comingSoon {
                                    opacity: 1;
                                    transition: .3s ease-in
                                }
                            }
                        }

                        &.monastery-hide {
                            opacity: 0;
                            right: 0;
                        }
                    }

                    .imgScrollDown7 {
                        cursor: pointer;
                        position: absolute;
                        bottom: 10px;
                        left: 50%;
                        transform: translate(-50%);
                    }
                }

                .ig {
                    padding-top: 102px;
                    width: 60%;
                    height: 100%;
                    background-image: url('../assets/img/background-seven.jpg');
                    background-size: cover;
                    overflow: hidden;

                    .list-ig {
                        opacity: 0;
                        width: 100%;
                        height: 100%;
                        background: rgba(112, 112, 112, 0.6);
                        transition: .5s linear;

                        &.show-ig-seven {
                            opacity: 1;
                        }

                    }
                }

                .bg-slide7-1 {
                    background-color: #D59D04;
                    position: absolute;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    max-height: 100vh;
                    transition: max-height .6s linear;
                    z-index: 6;
                    &.active-slide {
                        transition-delay: 0.8s;
                        height: 100%;
                        max-height: 0vh;
                    }
                }

                .bg-slide7-2 {
                    background-color: #D59D04;
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    height: 100%;
                    max-height: 0vh;
                    transition: max-height 0.4s linear; 
                    transition-delay: 0.4s;
                    z-index: 6;
                    &.active-slide {
                        transition: max-height 0.6s linear; 
                        transition-delay: 0s;
                        height: 100%;
                        max-height: 100vh;
                    }
                }

            } // close seven

            &.eight {
                display: flex;
                position: relative;
                .bg-slide8-1 {
                    background-color: #E13036;
                    position: absolute;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    max-height: 100vh;
                    transition: max-height .4s linear;
                    transition-delay: 0s;
                    z-index: 6;

                    &.active-slide {
                        transition: max-height .6s linear;
                        transition-delay: 0.8s;
                        height: 100%;
                        max-height: 0vh;
                    }
                }

                .bg-slide8-2 {
                    background-color: #E13036;
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    height: 100%;
                    max-height: 0vh;
                    transition: max-height .6s linear; 
                    z-index: 6;
                    &.active-slide {
                        height: 100%;
                        max-height: 100vh;
                    }
                }

                .description {
                    width: 33.33%;
                    height: 100%;
                    padding: 132px 50px 0 50px;
                    background-color: #E13036;
                    color: #FFFFFF;

                    ul {
                        list-style: none;
                        padding: 0;

                        li {
                            font-size: 30px;
                            font-weight: bold;
                            line-height: 35px;
                        }
                    }

                }

                .getting {
                    width: 33.33%;
                    height: 100%;
                    padding: 132px 50px 0 50px;
                    position: relative;
                    .box-getting {
                        .title {
                            font-size: 22px;
                            font-weight: bold;
                            color: #E13036;
                        }

                        .descript {
                            font-size: 13px;
                        }

                        .btn-getting {
                            font-size: 13px;
                            border-radius: 0px;
                            border: 1px #2C2C2C solid;
                            width: 140px;
                        }
                    }

                    .btnHome {
                        position: absolute;
                        left: 50%;
                        bottom: 20px;
                        transform: translate(-50%);
                    }
                }

                .zone {
                    width: calc(33.33% - 40px);
                    height: 100%;
                    padding: 132px 50px 0 50px;
                    background-image: url('../assets/img/background-eight.jpg');
                    background-size: cover;
                    background-position-x: -380px;

                    .box-zone {
                        display: flex;
                        flex-wrap: wrap;
                        color: #FFFFFF;
                        .detail-zone {
                            width: 50%;
                            height: 150px;
                            text-align: center;

                            .img-zone {
                                height: 50px;
                            }

                            div {
                                font-size: 10px;
                                &:nth-child(3) {
                                    margin-bottom: 15px;
                                }
                            }

                            .btn-zone {
                                border: 1px #FFFFFF solid;
                                border-radius: 0px;
                                font-size: 12px;
                                color: #FFFFFF;
                                
                            }
                        }
                    }
                }
            }

        } // close .slide
    }

    @media only screen and (min-width: 1280px) {
        .slides-container {
            .slide {
                &.first {
                    .detail {
                        padding-top: 0px;

                        .title {
                            font-size: 22px;
                        }

                        .welcome {
                            font-size: 36px;
                        }

                        .map-zoom { 
                            width: 150px;
                            height: 150px;
                            img {
                                width: 85%;
                            }
                        }

                        .description {
                            padding: 0 50px;
                            margin-top: 10px;
                            font-size: 12px;
                        }
                    }

                    .img-scroll {
                        cursor: pointer;
                        position: absolute;
                        bottom: 20px;
                        left: 50%;
                        transform: translate(-50%);
                        width: 70px;
                    }

                    .what-do-you {
                        &.active {
                            z-index: 5;
                            opacity: 1;
                            transition: .3s ease-in-out;

                            .text-what-do-you {
                                padding-top: 60px;

                                ul {
                                    position: relative;
                                    left: 40%;
                                    transform: translate(-50%);

                                    li {
                                        opacity: 1;
                                    }
                                }
                            }
                        }
                    }
                }

                &.in-zoom {
                    .detail {
                        .title,.welcome,.description>p {
                            opacity: 1;
                        }

                        .map-zoom {
                            opacity: 1;
                            transition: .6s ease-in;
                        }
                    }

                    .zoom {
                        opacity: 0;
                        top: 220px;
                        right: 295px;
                        width: 150px;
                        height: 150px;
                        border-radius: 50%;
                        border: 5px solid #F4F4F4;
                        .bg-map {
                            transform: translate(-50%, -50%);
                            top: 240px;
                            left: -240px;
                        }
                    }
                }
            }
        }    
    }

    @media only screen and (min-width: 1600px) {
        .slides-container {
            .slide {

                &.first {
                    .detail {
                        width: 55%;
                        height: 100%;
                        padding-top: 30px;
                        padding-left: 50px;
                        padding-right: 50px;

                        .title {
                            font-size: 33px;
                        }

                        .welcome {
                            font-size: 60px;
                        }

                        .description {
                            p {
                                font-size: 15px;
                            }
                        }
                    }

                    .what-do-you {
                        .text-what-do-you {
                            padding-top: 60px;
                            padding-left: 520px;
                            padding-bottom: 130px;

                            ul {
                                li {
                                    font-size: 100px;
                                    line-height: 100px;
                                }
                            }
                        }
                    }
                }

                &.two {
                    .detail-two {
                        .description {
                            

                            .description-first {
                                li {
                                    font-size: 45px;
                                    line-height: 50px;
                                }
                            }

                            .description-two {
                                margin-top: 50px; 
                                padding-right: 150px;
                                p {
                                    font-size: 15px;
                                }

                                .exploreOur {
                                    bottom: 170px;
                                    right: calc(280px + 40px);
                                }
                            }
                        }
                    }
                }

                &.three {
                    .description {
                        padding: 152px 120px 0 30px;
                        ul {
                            li {
                                font-weight: bold;
                                font-size: 50px;
                                line-height: 55px;
                            }
                        }

                        p {
                            font-size: 15px;
                        }

                        img {
                            position: relative;
                            left: 50%;
                            transform: translate(-50%);
                        }
                    }
                    .img-three {

                        .box-historical {
                            bottom: 155px;
                            left: 550px;
                            width: 255px;

                            img {
                                width: 100%;
                            }

                            .title {
                                font-size: 16px;
                                font-weight: bold;
                            }

                            .lorem {
                                font-size: 12px;
                            }

                            .btn-historical {
                                font-size: 15px;
                            }
                        }
                        
                    }
                }

                &.four {
                    .description {
                        ul {
                            li {
                                font-size: 50px;
                                line-height: 60px;
                            }
                        }

                        p {
                            font-size: 15px;
                        }

                        .box-bohemian {
                            bottom: 95px;
                            left: 50px;
                            width: 255px;
                            
                            img {
                                width: 100%;
                            }

                            .title {
                                font-size: 16px;
                                font-weight: bold;
                                color: #000;
                            }

                            .lorem {
                                font-size: 12px;
                                color: #000;
                            }

                            .btn-bohemian {
                                font-size: 15px;
                            }
                        }
                    }
                }

                &.five {
                    .description {
                        padding: 132px 150px 0 110px;

                        ul {
                            li {
                                font-size: 50px;
                                line-height: 60px;
                            }
                        }
                        .detail {
                            p {
                                font-size: 15px;
                            }
                        }

                        .box-camping {
                            top: 142px;
                            right: 194px;
                            width: 255px;
                            
                            img {
                                width: 100%;
                            }

                            .title {
                                font-size: 16px;
                            }

                            .lorem {
                                font-size: 12px;
                            }

                            .btn-camping {
                                font-size: 13px;
                            }
                        }
                        
                    }

                    .ig {
                        width: 50%;
                        height: 40%;
                        position: absolute;
                        bottom: -100%;
                        right: 95px;
                        background-color: rgba(112, 112, 112, 0.6);
                        transition: .5s linear;

                        &.show-ig-five {
                            bottom: 130px;
                        }
                    }
                }

                &.six {
                    .description {
                        padding-left: 80px;
                        padding-right: 130px;

                        ul {
                            li {
                                font-size: 50px;
                                line-height: 60px;
                            }
                        }

                        p {
                            font-size: 15px;
                        }

                        .box-festival {
                            bottom: 170px;
                            left: -190px;
                            width: 255px;
                            
                            img {
                                width: 100%;
                            }

                            .title {
                                font-size: 16px;
                                font-weight: bold;
                                
                                color: #000;
                            }

                            .lorem {
                                font-size: 12px;
                                color: #000;
                            }

                            .btn-festival {
                                background-color: #E13036;
                                border-radius: 0px;
                                color: #FFFFFF;
                                font-size: 15px;
                            }

                            &.festival-hide {
                                opacity: 0;
                                left: 0;
                            }
                        }

                        .imgScrollDown6 {
                            cursor: pointer;
                            position: absolute;
                            bottom: 10px;
                            left: 50%;
                            transform: translate(-50%);
                        }
                    } 
                }

                &.seven {
                    .description {
                        width: 45%;
                        padding: 182px 100px 0px 100px;
                        ul {
                            li {
                                font-size: 50px;
                                line-height: 60px;
                            }
                        }

                        p {
                            padding-right: 80px;
                            font-size: 15px;
                        }

                        .box-monastery {
                            bottom: 75px;
                            right: -125px;
                            width: 255px;
                            
                            img {
                                width: 100%;
                            }

                            .title {
                                padding-right: 0;
                                font-size: 16px;
                                font-weight: bold;
                            }

                            .lorem {
                                padding-right: 0;
                                font-size: 12px;
                            }

                            .btn-monastery {
                                font-size: 13px;
                            }
                        }
                    }

                    .ig {
                        width: 55%;
                    }
                }
            }
        }
    }

    @media only screen and (min-width: 1920px) {
        .slides-container {
            .slide {

                &.first {
                    .detail {
                        width: 55%;
                        height: 100%;
                        padding-top: 30px;
                        padding-left: 120px;
                        padding-right: 120px;

                        .title {
                            font-size: 33px;
                        }

                        .welcome {
                            font-size: 60px;
                        }

                        .description {
                            p {
                                font-size: 15px;
                            }
                        }
                    }

                    .what-do-you {
                        .text-what-do-you {
                            padding-top: 60px;
                            padding-left: 680px;
                            padding-bottom: 130px;

                            ul {
                                li {
                                    font-size: 100px;
                                    line-height: 100px;
                                }
                            }
                        }
                    }
                }

                &.two {
                    .detail-two {
                        .description {
                            padding: 182px 80px 0px 80px;
                            .description-first {
                                li {
                                    font-size: 60px;
                                    line-height: 65px;
                                }
                            }

                            .description-two {
                                margin-top: 50px; 
                                padding-right: 150px;
                                p {
                                    font-size: 15px;
                                }

                                .exploreOur {
                                    bottom: 80px;
                                    right: calc(380px + 40px);
                                }
                            }
                        }
                    }
                }

                &.three {
                    .description {
                        padding: 172px 180px 0 120px;
                        ul {
                            padding-bottom: 50px;
                            li {
                                font-size: 60px;
                                line-height: 65px;
                            }
                        }

                        p {
                            font-size: 15px;
                        }

                        img {
                            position: relative;
                            left: 50%;
                            transform: translate(-50%);
                        }
                    }
                    .img-three {

                        .box-historical {
                            bottom: 190px;
                            left: 650px;
                            width: 255px;

                            img {
                                width: 100%;
                            }

                            .title {
                                font-size: 16px;
                                font-weight: bold;
                            }

                            .lorem {
                                font-size: 12px;
                            }

                            .btn-historical {
                                font-size: 15px;
                            }
                        }
                        
                    }
                }

                &.four {
                    .description {
                        width: 45%;
                        padding-top: 182px;
                        padding-right: 100px;
                        ul {
                            padding-bottom: 50px;
                            li {
                                font-size: 60px;
                                line-height: 65px;
                            }
                        }

                        p {
                            font-size: 15px;
                        }

                        .box-bohemian {
                            bottom: 45px;
                            left: 50px;
                            width: 255px;
                            
                            img {
                                width: 100%;
                            }

                            .title {
                                font-size: 16px;
                                font-weight: bold;
                                color: #000;
                            }

                            .lorem {
                                font-size: 12px;
                                color: #000;
                            }

                            .btn-bohemian {
                                font-size: 15px;
                            }
                        }
                    }
                }

                &.five {
                    .description {
                        padding: 182px 150px 0 110px;

                        ul {
                            padding-bottom: 30px;
                            li {
                                font-size: 60px;
                                line-height: 65px;
                            }
                        }
                        .detail {
                            p {
                                font-size: 15px;
                            }
                        }

                        .box-camping {
                            top: 182px;
                            right: 194px;
                            width: 255px;
                            
                            img {
                                width: 100%;
                            }

                            .title {
                                font-size: 16px;
                            }

                            .lorem {
                                font-size: 12px;
                            }

                            .btn-camping {
                                font-size: 13px;
                            }
                        }
                        
                    }

                    .ig {
                        width: 50%;
                        height: 40%;
                        position: absolute;
                        bottom: -100%;
                        right: 95px;
                        background-color: rgba(112, 112, 112, 0.6);
                        transition: .5s linear;

                        &.show-ig-five {
                            bottom: 80px;
                        }
                    }
                }

                &.six {
                    .description {
                        padding-top: 182px;
                        padding-left: 113px;
                        padding-right: 150px;

                        ul {
                            padding-bottom: 50px;
                            li {
                                font-size: 60px;
                                line-height: 65px;
                            }
                        }

                        p {
                            font-size: 15px;
                        }

                        .box-festival {
                            bottom: 130px;
                            left: -190px;
                            width: 255px;
                            
                            img {
                                width: 100%;
                            }

                            .title {
                                font-size: 16px;
                                font-weight: bold;
                            }

                            .lorem {
                                font-size: 12px;
                            }

                            .btn-festival {
                                font-size: 15px;
                            }
                        }

                        .imgScrollDown6 {
                            cursor: pointer;
                            position: absolute;
                            bottom: 10px;
                            left: 50%;
                            transform: translate(-50%);
                        }
                    } 
                }

                &.seven {
                    .description {
                        width: 45%;
                        padding: 182px 100px 0px 100px;
                        ul {
                            padding-bottom: 50px;
                            li {
                                font-size: 60px;
                                line-height: 65px;
                            }
                        }

                        p {
                            padding-right: 80px;
                            font-size: 15px;
                        }

                        .box-monastery {
                            bottom: 75px;
                            right: -125px;
                            width: 255px;
                            
                            img {
                                width: 100%;
                            }

                            .title {
                                padding-right: 0;
                                font-size: 16px;
                                font-weight: bold;
                            }

                            .lorem {
                                padding-right: 0;
                                font-size: 12px;
                            }

                            .btn-monastery {
                                font-size: 13px;
                            }
                        }
                    }

                    .ig {
                        width: 55%;
                    }
                }

                &.eight {
                    .description {
                        padding: 192px 50px 0 50px;

                        ul {
                            li {
                                font-size: 56px;
                                line-height: 61px;
                            }
                        }

                    }

                    .getting {
                        padding: 182px 50px 0 50px;

                        .box-getting {
                            .title {
                                font-size: 38px;
                            }
                        }
                    }

                    .zone {
                        width: calc(33.33% - 40px);
                        height: 100%;
                        padding: 132px 50px 0 50px;
                        background-image: url('../assets/img/background-eight.jpg');
                        background-size: cover;
                        background-position-x: -380px;

                        .box-zone {
                            .detail-zone {
                                width: 50%;
                                height: 180px;
                                text-align: center;
                                position: relative;
                                margin-bottom: 50px;

                                .img-zone {
                                    height: 50px;
                                }

                                div {
                                    font-size: 16px;
                                }

                                .btn-zone {
                                    font-size: 16px;
                                    position: absolute;
                                    bottom: 5px;
                                    left: 50%;
                                    transform: translate(-50%);

                                    &.btn-long {
                                        width: 180px;
                                    }
                                }
                            }
                        }
                    }
                }

                &.in-zoom {

                    .zoom {
                        top: 335px;
                        right: 422px;
                    }
                }
            }
        }    
    }
}
</style>
